import { TROUBLESHOOTING_GUIDES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/troubleshooting_guides_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['troubleshootingGuidesIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
